import type NonEmptyText from '../non-empty-text';
import type StakeholderType from './stakeholder-type';
import type Store from './store';

export interface IStakeholder {
	readonly key: NonEmptyText;
	readonly stakeholderType: StakeholderType;
	readonly store: Store;
}

export default class Stakeholder implements IStakeholder {
	public get key(): NonEmptyText {
		return this.#key;
	}

	public get stakeholderType(): StakeholderType {
		return this.#stakeholderType;
	}

	public get store(): Store {
		return this.#store;
	}

	#key: NonEmptyText;
	#stakeholderType: StakeholderType;
	#store: Store;
	public constructor({ key, stakeholderType, store }: IStakeholder) {
		this.#key = key;
		this.#stakeholderType = stakeholderType;
		this.#store = store;
	}
}
